export default {
  title: "403 禁止訪問",
  description: "抱歉，您沒有權限訪問此頁面。如果您認為這是錯誤，請聯繫您的管理員。",
  goHome: "回到首頁",
  goBack: "返回上一頁",
};
